import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { Link, LinkIcon } from '../'
import config from '../../config'
import Styles from './DonateBanner.css'

@CSSModules(Styles)
export default class DonateBanner extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }
  render() {
    return (
      <div styleName='banner-wrap'>
        <div styleName='banner'>
          <div styleName='banner-inner'>
            <div>
              <div styleName='banner-headline'>
                Your support keeps this working
              </div>
              <div styleName='banner-subtitle'>
                Make a gift today to support As You Sow, a 501c3 non-profit
              </div>
              <div styleName='banner-logo'>
                <Link
                  to={config.links.ays}
                  title='As You Sow'>
                  <div styleName='ays' title='As You Sow'/>
                </Link>
              </div>
            </div>
            <Link
              to={config.links.donate}
              donatebanner={true}
              title='Donate to As You Sow'>
              <span styleName='nowrap'>
                Donate<LinkIcon/>
              </span>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

